import { useContext, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Select } from "../../../components/forms/select";
import { flags, useLanguages } from "../../../i18n";
import { mapObject } from "../../../utils/utils";
import { ConfigContext } from "./config-context";

export interface ILanguagePickerProps {}

const StyledSelect = styled(Select)`
  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiSelect-selectMenu {
    min-height: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const Container = styled.div`
  top: 1em;
  right: 1em;
  margin-bottom: 0.5em;
  display: flex;
  justify-content: flex-end;
`;

const LabelMap = {
  "en-GB": "EN",
  "es-ES": "ES",
};

export function LanguagePicker(props: ILanguagePickerProps) {
  const { languages, selectLanguage, current } = useLanguages();
  const [currentLanguage, setCurrentLanguage] = useState(current);
  const { config } = useContext(ConfigContext);

  useEffect(() => {
    setCurrentLanguage(current);
  }, [current]);

  useEffect(() => {
    if (
      !config.configuration.supportedFormLanguages.includes(
        currentLanguage.replaceAll("-", "_")
      )
    ) {
      setCurrentLanguage("en-GB");
      selectLanguage("en-GB", true);
    }
  }, []);

  const options = useMemo(
    () =>
      mapObject(languages, (val, key) => ({
        value: key,
        title: (
          <div>
            {flags[key]} {LabelMap[key]}
          </div>
        ),
      })).filter((val) =>
        config.configuration.supportedFormLanguages.includes(
          val.value.replaceAll("-", "_")
        )
      ),
    [languages]
  );

  return options.length > 1 ? (
    <Container>
      <StyledSelect
        options={options}
        value={currentLanguage}
        onChange={(e) => {
          setCurrentLanguage(e.target.value as string);
          selectLanguage(e.target.value);
        }}
      />
    </Container>
  ) : null;
}
